import React, { Component } from 'react'

export class AffectationChambre extends Component {
    render() {
        return (
            <div>
                Component AffectationChambre
            </div>
        )
    }
}

export default AffectationChambre
